import React from "react";

/** Linked tables; square nodes keep it apart from Share's round ones. */
export const GraphModeIcon = (props: {
  className?: string;
  style?: React.CSSProperties;
}): React.JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    data-testid="GraphModeIcon"
    {...props}
  >
    <rect x="3" y="3" width="6" height="6" rx="1.6" />
    <rect x="15" y="7" width="6" height="6" rx="1.6" />
    <rect x="5" y="15" width="6" height="6" rx="1.6" />
    <path d="M9 7l6 2M15 12.4l-4 3.2" />
  </svg>
);
